<template>

</template>

<script>
import {create as createWebsite} from "../../js/services/editor/website";

import {mapGetters} from "vuex";

export default {
  name: "CreateWebsiteWithoutTemplate",
  computed: {
    ...mapGetters({user: 'user'}),
  },
  watch: {
    'user': {
      deep: true,
      handler(value) {

        if (this.user && this.user.email) {
          // let flag = 'website';
          // if (this.$route.query.flag) {
          //   flag = this.$route.query.flag;
          // }
          //
          // createWebsite({
          //   title: this.$t('ct-my-website-title'),
          //   description: this.$t('ct-my-website-description'),
          //   type: 'template',
          //   language: this.user.lang ? this.user.lang : 'en_US',
          //   template_flag: flag,
          // })
          //   .then(res => {
          //     if (res.data.success === false) {
          //       this.$snotify.warning(this.$t(res.data.error));
          //     } else {
          //       this.$router.push({
          //         name: 'SitePages',
          //         params: {id: res.data.encrypted_id},
          //         query: {tour: 'active'}
          //       });
          //     }
          //   })
          //   .finally(() => this.$loading.hide());
        }
      }
    },
  },
  mounted() {
    this.$loading.show();

    this.$nextTick(() => {
      let flag = 'website';
      if (this.$route.query.flag) {
        flag = this.$route.query.flag;
      }

      createWebsite({
        title: this.$t('ct-my-website-title'),
        description: this.$t('ct-my-website-description'),
        type: 'template',
        language: 'en_US',
        template_flag: flag,
      })
        .then(res => {
          if (res.data.success === false) {
            this.$snotify.warning(this.$t(res.data.error));
          } else {
            this.$router.push({
              name: 'SitePages',
              params: {id: res.data.encrypted_id},
              query: {tour: 'active'}
            });
          }
        })
        .finally(() => this.$loading.hide());
    });
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/CreateWebsiteWithoutTemplate.vue